export function formatBytes(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
}

export function formatTime(ms?: number): string {
  if (ms === undefined || ms === null) return '-';
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}

export function formatDate(date: Date): string {
  return date.toLocaleString('cs-CZ', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function escapeHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function uid(): string {
  return Math.random().toString(36).slice(2, 10);
}

export function formatPathLabel(path: string): string {
  const parts = path.split('.');
  if (parts.length <= 2) return path;
  return parts.slice(-2).join('.');
}

export function downloadJSON(data: any, filename: string) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadBase64(base64: string, filename: string, mimeType: string) {
  const byteChars = atob(base64);
  const byteArr = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
  const blob = new Blob([byteArr], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/* ───── localStorage persistence ───── */
const STORAGE_KEY = 'ocr_pinned_results';

/** Save pinned results to localStorage. Returns false on QuotaExceededError. */
export function savePinnedResults(results: any[], pinnedIds: Set<string>): boolean {
  try {
    const pinned = results.filter(r => pinnedIds.has(r.fileGroupId));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pinned));
    return true;
  } catch (e) {
    return false;
  }
}

/** Load pinned results from localStorage. Converts timestamp strings back to Date. */
export function loadPinnedResults(): { results: any[], pinnedIds: Set<string> } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { results: [], pinnedIds: new Set() };
    const parsed = JSON.parse(raw) as any[];
    const results = parsed.map(r => ({ ...r, timestamp: new Date(r.timestamp) }));
    const pinnedIds = new Set<string>(results.map(r => r.fileGroupId));
    return { results, pinnedIds };
  } catch {
    return { results: [], pinnedIds: new Set() };
  }
}

/** Clear all pinned data from localStorage. */
export function clearPinnedStorage(): void {
  localStorage.removeItem(STORAGE_KEY);
}
